import { Button } from "shared/ui/button";
import { notifyError, notifySuccess } from "shared/ui/toast";

export const Dev = () => {
  return (
    <div>
      <Button
        onClick={() => {
          notifySuccess("SUCCESS");
        }}
      >
        Success
      </Button>
      <Button
        onClick={() => {
          notifyError("ERROR");
        }}
      >
        Error
      </Button>
    </div>
  );
};
